import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function AdminNav() {
  const location = useLocation();

  const navItems = [
    { path: "/admin", label: "Dashboard", icon: "📊" },
    { path: "/admin/traffic", label: "Traffic", icon: "📈" },
    { path: "/admin/products", label: "Products", icon: "🕶️" },
    { path: "/admin/images", label: "Images", icon: "🖼️" },
    { path: "/admin/users", label: "Users", icon: "👥" },
    { path: "/admin/orders", label: "Orders", icon: "📦" },
    { path: "/admin/emails", label: "Emails", icon: "✉️" },
    { path: "/admin/inbox", label: "Inbox", icon: "📨" },
    { path: "/admin/settings", label: "Settings", icon: "⚙️" },
  ];

  const isActive = (path) => {
    if (path === "/admin") {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bg-gray-900 border-b border-gray-800 mb-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center space-x-1 overflow-x-auto">
          {navItems.map((item) => (
            <Link key={item.path} to={item.path} className={`px-6 py-4 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${isActive(item.path) ? "border-gold-500 text-gold-500" : "border-transparent text-gray-400 hover:text-white hover:border-gray-600"}`}>
              <span className="mr-2">{item.icon}</span>
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
